/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Note_ErrorInputs */

const en_us2_profile_editors_pain_note_error = /** @type {(inputs: Profile_Editors_Pain_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use at most 280 characters.`)
};

const pt_br2_profile_editors_pain_note_error = /** @type {(inputs: Profile_Editors_Pain_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use no máximo 280 caracteres.`)
};

const es_419_profile_editors_pain_note_error = /** @type {(inputs: Profile_Editors_Pain_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa como máximo 280 caracteres.`)
};

const pt_pt2_profile_editors_pain_note_error = /** @type {(inputs: Profile_Editors_Pain_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa no máximo 280 caracteres.`)
};

const fr_fr2_profile_editors_pain_note_error = /** @type {(inputs: Profile_Editors_Pain_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`280 caractères maximum.`)
};

const de_de2_profile_editors_pain_note_error = /** @type {(inputs: Profile_Editors_Pain_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstens 280 Zeichen.`)
};

const it_it2_profile_editors_pain_note_error = /** @type {(inputs: Profile_Editors_Pain_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa al massimo 280 caratteri.`)
};

/**
* | output |
* | --- |
* | "Use at most 280 characters." |
*
* @param {Profile_Editors_Pain_Note_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_note_error = /** @type {((inputs?: Profile_Editors_Pain_Note_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Note_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_note_error(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_note_error(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_note_error(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_note_error(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_note_error(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_note_error(inputs)
	return en_us2_profile_editors_pain_note_error(inputs)
});
export { profile_editors_pain_note_error as "profile-editors.pain_note_error" }